module.exports = __webpack_public_path__ + "img/report-5.006c72bb.jpg";